import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ProfileService {
  static getRiskData(encodeParam, sId) {
    return HttpUtil.get(
      API_ROUTES.PROFILE.RISKDATA + `${encodeParam}/supplier/${sId}/riskscore`
    );
  }

  static getProfileData(encodedUrlParam) {
    return HttpUtil.get(
      API_ROUTES.PROFILE.PROFILEDATA.replace("<encodedUrlParam>", encodedUrlParam)
    );
  }
  static getSupplierRiskScore(encodedUrlParam, supplierId, date) {
    return HttpUtil.get(
      API_ROUTES.PROFILE.SUPPLIERRISKSCORE.replace("<encodedUrlParam>", encodedUrlParam)
        .replace("<supplierId>", supplierId)
        .replace("<date>", date)
    );
  }
  static getProfileStatus(encodedUrlParam) {
    return HttpUtil.get(
      API_ROUTES.PROFILE.PROFILESTATUS.replace("<encodedUrlParam>", encodedUrlParam)
    );
  }

  static getConsultantCompanies() {
    return HttpUtil.get(
      API_ROUTES.CONSULTANT.GET_COMPANIES
    );
  }

  static switchCompanyAsConsultant(companyId) {
    return HttpUtil.patch(
      API_ROUTES.CONSULTANT.SWITCH_COMPANY.replace('<companyId>', companyId)
    );
  }
}
